import { Injectable } from '@angular/core';

import _set from 'lodash-es/set';
import _forEach from 'lodash-es/forEach';
import _get from 'lodash-es/get';
import _filter from 'lodash-es/filter';
import _last from 'lodash-es/last';
import _max from 'lodash-es/max';
import _values from 'lodash-es/values';
import _toNumber from 'lodash-es/toNumber';
import _unset from 'lodash-es/unset';
import _capitalize from 'lodash-es/capitalize';
import _isObject from 'lodash-es/isObject';
import { DateService } from "libraries/date/date.service";
import * as moment from "moment";

// Import RxJs required methods


@Injectable()
export class TravellerService {

    public traveller: any = {};

    public response: any = {data: {}, display: {}};

    private readonly $post = JSON.parse(sessionStorage.getItem('$post'));


    constructor(private readonly dateService: DateService,) {
    }

    public getTraveller(_searchRQ: any): any {
        if (_searchRQ.traveller) {
            // this.traveller = _searchRQ.traveller;
            let i = 1;
            // tslint:disable-next-line:no-any
            const travellers: any = {};
            _forEach(_searchRQ.traveller, (travellerData: any) => {

                //define key
                let key = _searchRQ.traveller.xId ? _searchRQ.traveller.xId : "T_" + i;
                i++;
                //populate propalResponse.traveller

                _set(travellers, [key], travellerData);
                _set(travellers, [key, 'id'], key);
                _set(travellers, [key, 'xId'], key);
                if (travellerData.birthDate && typeof travellerData.birthDate === "string" && travellerData.birthDate.indexOf('-') > 0) {
                    // remove utc cause day -1 see ticket #31351
                    _set(travellers, [key, 'birthDate'], moment(travellerData.birthDate).toDate());
                    // _set(travellers, [key, 'birthDate'], this.dateService.getStr2JsDate(travellerData.birthDate));
                }
                const passportDate: string = _get(travellerData, 'passport.validity.end');
                if (typeof passportDate === "string" && passportDate.indexOf('-') > 0) {
                    _set(travellers, [key, 'passport', 'validity', 'end'], moment.utc(passportDate).toDate());
                    // _set(travellers, [key, 'passport', 'validity', 'end'], this.dateService.getStr2JsDate(passportDate));
                }
                const identityCardDate: string = _get(travellerData, 'identityCard.validity.end');
                if (typeof identityCardDate === "string" && identityCardDate.indexOf('-') > 0) {
                    _set(travellers, [key, 'identityCard', 'validity', 'end'], moment.utc(identityCardDate).toDate());
                    // _set(travellers, [key, 'passport', 'validity', 'end'], this.dateService.getStr2JsDate(passportDate));
                }

            });
            this.traveller = travellers;
            this.verifyAPIS();
            return this.traveller;
        } else if (_searchRQ.quantity) {
            return this.getTravellerFromQuantity(_searchRQ.quantity);
        }
        return [];
    }

    public getTravellerFromQuantity(_quantity: any): any {

        const oldTraveller: any | any[] = {};

        oldTraveller.adult = _filter(this.traveller, (pax) => pax.type === 'Adult');
        oldTraveller.child = _filter(this.traveller, (pax) => pax.type === 'Child');
        oldTraveller.infant = _filter(this.traveller, (pax) => pax.type === 'Infant');
        const lastIndex: any = {};


        const typeArray = ['adult', 'child', 'infant'];

        //Test each type...
        _forEach(typeArray, (_type: string) => {
            const nbFromForm = _get(_quantity, _type);
            const nbOld = _get(oldTraveller, _type).length;


            //if we have remove pax from this type
            if (nbOld > nbFromForm) {
                for (let _i = nbOld - 1; _i > nbFromForm - 1; _i--) {
                    const key = oldTraveller[_type][_i].id;
                    _unset(this.traveller, key);
                }

                //then define lest index


                //or we have add
            }
        });

        _forEach(typeArray, (_type: string) => {
            const nbFromForm: number = _get(_quantity, _type);
            const nbOld: number = _get(oldTraveller, _type).length;

            oldTraveller.adult = _filter(this.traveller, (pax) => pax.type === 'Adult');
            oldTraveller.child = _filter(this.traveller, (pax) => pax.type === 'Child');
            oldTraveller.infant = _filter(this.traveller, (pax) => pax.type === 'Infant');
            lastIndex.adult = _last(oldTraveller.adult) ? _last((_last<any>(oldTraveller.adult)).id) : 0;
            lastIndex.child = _last(oldTraveller.child) ? _last((_last<any>(oldTraveller.child)).id) : 0;
            lastIndex.infant = _last(oldTraveller.infant) ? _last((_last<any>(oldTraveller.infant)).id) : 0;

            const lastKeyIndex: number = _max(_values(lastIndex));

            const nbToAdd : number= nbFromForm - nbOld;

            for (let _i: number = _toNumber(lastKeyIndex) + 1; _i <= _toNumber(lastKeyIndex) + nbToAdd; _i++) {

                const key: string = `T_${_i}`;

                _set(this.traveller, [key, 'type'], _capitalize(_type));
                _set(this.traveller, [key, 'id'], key);
                _set(this.traveller, [key, 'xId'], key);
            }

        });

        this.verifyAPIS();
        return this.traveller;
    }

    public countType(type: string): number {
        let output: number = 0;
        if (this.$post.traveller) {


            _forEach(this.traveller, (travellerData: any, travellerId: string) => {
                if (travellerData.type === type) {
                    output++;
                }
            });


        }
        return output;
    }


    public getTravellersList(context?: string): string[] {
        if (context === 'ssr') {

            if (_isObject(this.traveller)) {
                return _values(this.traveller);
            } else {

                return this.traveller;
            }
            // return this.$post.traveller;
        }

        const output: string[] = [];

        if (this.traveller) {
            for (const item of this.traveller) {
                output.push(item.firstName + " " + item.lastName);
            }
        }

        return output;
    }

    public verifyAPIS(): void {
        const APISListAdult: string[] = [
            "birthDate", "passport", "citizenship"
        ];
        const APISListChild: string[] = [
            "passport", "citizenship"
        ];
        const passportFields: string[] = ['number', 'validity', 'issuance'];

        if (!this.response.display.errorTraveller) {
            this.response.display.errorTraveller = [];
        }

        _forEach(this.traveller, (element: any, index: any) => {
            let APISList: string[] = APISListAdult;

            if (element.type && element.type === 'Infant' || element.type === 'Child') {
                APISList = APISListChild;
            }
            this.response.display.errorTraveller[index] = [];

            //test if absents
            _forEach(APISList, (APISName: string) => {
                if (!element[APISName]) {
                    this.response.display.errorTraveller[index].push(APISName);
                }
            });


            if (element.passport) {
                _forEach(passportFields, (ppfield: any) => {
                    if (!element.passport[ppfield]) {
                        this.response.display.errorTraveller[index].push("pp" + ppfield);
                    }
                });

            }
        });
    }

    public getQuantityFromTraveller(travellers): { adult: number, child: number, infant: number } {
        const quantity: { adult: number, child: number, infant: number } = {adult: 0, child: 0, infant: 0};
        (travellers || []).forEach((traveller) => {
            const type: string = traveller.type || 'Adult';
            quantity[type.toLowerCase()]++;
        });

        return quantity;
    }

}
